import { useEffect, useState } from "react";
import { Alert, Col, Container, Row, Button, Image } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { useParams } from "react-router";
import Get from "../api/Get";
import {
  ACCOUNT_CONF_MESSAGES_GET_BY_ID,
  ACCOUNT_SETTING_GET_BY_ID,
  BASE_URL_WS,
  GET_ACCOUNT_SIN_TOKEN,
} from "../api/Routes";
import StepOneCLB from "../components/autoagendamiento/StepOneCLB";
import StepTreeCuenta from "../components/autoagendamiento/StepTreeCuenta";
import StepTwo from "../components/autoagendamiento/StepTwo";
import useTheme from "../hook/useTheme";
import LoadingList from "../loader/LoadingList";
import WebFont from "webfontloader";
import { ThemeProvider } from "styled-components";
import { GlobalStyles } from "../theme/GlobalStyles";
import * as themes from "../theme/schema.json";
import ComponentModalErrorSever from "../components/ComponentModalErrorSever";
import StepEPSOnly from "../components/autoagendamiento/StepEPSOnly";
import { getTokenExternal } from "../utils/getTokenExternal";
import SockJsClient from "react-stomp";
import DeclinadoLegalWarning from "../components/conferencepublic/DeclinadoLegalWarning";
import imgOops from '../img/oops.png'

function AgendamientoCuenta({ t }) {
  const { idAccount } = useParams();
  const [loading, setLoading] = useState(true);
  const [reservadoExitosamente, setReservadoExitosamente] = useState(false);
  const [isPedienteAprobacion, setIsPendienteAprobacion] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [phoneNumber2, setPhoneNumber2] = useState(null);
  const [tipoSangre, setTipoSangre] = useState("");
  const [source, setSource] = useState("flujoallianz");
  const [fieldSettings, setFieldSettings] = useState([]);
  const [declined, setDeclined] = useState(false);
  const [statusCuenta, setStatusCuenta] = useState(null);

  //server error
  const [showModalError, setShowModalError] = useState(false);
  const [errorServer, setErrorServer] = useState(null);
  const handleClose = () => setShowModalError(false);

  const { theme, setTheme, getFonts, getFontsLocale } = useTheme();

  const [camino, setCamino] = useState([0]);
  const [existeCompania, setExisteCompania] = useState("check");

  //payment
  const [payment, setPayment] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState("currentflow");

  //configuration account
  const [configuration, setConfiguration] = useState(null);

  useEffect(() => {
    if (parseInt(idAccount) === 57) {
      setTheme(themes.data.allianz);
      setSource("flujoallianz");
    } else if (parseInt(idAccount) === 68) {
      setSource("autoagendamientovardi");
    } else if (parseInt(idAccount) === 144) {
      setSource("autoagendamientonuevoeps");
    }
  }, []);

  useEffect(() => {
    WebFont.load({
      google: {
        families: getFonts(),
      },
      custom: {
        families: getFontsLocale(),
      },
    });
  }, []);

  const initColombusA = {
    id: "",
    roadType: "",
    streetField1: "",
    streetField2: "",
    streetField3: "",
    propertyNumber: "",
    propertyType: "",
    propertyTypeAdditional: "",
    unitNumber: "",
  };
  const [initialData, setInitialData] = useState({
    id: "",
    name: "",
    middleName: "",
    seccondSurname: "",
    lastName: "",
    gender: "",
    dateOfBirthday: "",
    nationality: "",
    externalId: "",
    phoneNumber: "",
    phoneNumber2: "",
    email: "",
    bloodType: "",
    occupacion: "",
    ocupacion_name: "",
    address: "",
    peso: "",
    talla: "",
    sintomas: "",
    dayAppointment: "",
    doctorId: "",
    hourDayId: "",
    hourDayHour: "",
    doctorName: "",
    especialidadName: "",
    especialidadId: "",
    account: "",
    currentInsurance: "",
    aceptarTerminos: true,
    location: "",
    location_name: "",
    neighborhood: "",
    identityDocumentType: "",
    documentNumber: "",
    choiceType: "",
    identityDocumentTypeModel: "",
    country_name: "",
    countryBirth_name: "",
    state_name: "",
    municipio_name: "",
    patientRelationship: "",
    hourInit: "",
    countryBirth: "",
    colombusAddress: initColombusA,
    propertyType_name: "",
    roadType_name: "",
    propertyTypeAdditional_name: "",
    documentoTitular: "",
    eps: {
      id: "",
      nombreEps: "",
      codigo: "",
    },
    tipoPlan: "",
    titular: {
      documentNumber: "",
      identityDocumentType: {
        id: "",
      },
    },
  });
  const [currentStep, setCurrentStep] = useState(0);

  const handleNextStep = (newData, final = false) => {
    setInitialData((prev) => ({ ...prev, ...newData }));
    setCurrentStep((prev) => prev + 1);
  };

  //const [startFromEPS, setStartFromEPS] = useState(parseInt(idAccount) === 144 ? true: false)
  const [startFromEPS, setStartFromEPS] = useState(false);
  useEffect(() => {
    if (currentStep === 0) {
      setCamino([0]);
    } else if (currentStep === 1) {
      setCamino([0, 1]);
    } else {
      setCamino([0, 1, 2]);
    }
  }, [currentStep]);

  const handlePrevStep = (newData) => {
    setInitialData((prev) => ({ ...prev, ...newData }));
    setCurrentStep((prev) => prev - 1);
  };
  useEffect(() => {
    async function getFields() {
      try {
        const tokenObj = await getTokenExternal(
          initialData.company
            ? initialData.company
            : initialData.account.partner.company
        );
        if (tokenObj.status === 200) {
          const { access_token } = tokenObj.data;
          const response = await Get({
            url: `${ACCOUNT_SETTING_GET_BY_ID}/${initialData.account.id}`,
            access_token: access_token,
          });
          //console.log(response)
          if (response.data.state) {
            setFieldSettings(response.data?.data?.formSettingsDTOList || []);
          }

          const responseConf = await Get({
            url: `${ACCOUNT_CONF_MESSAGES_GET_BY_ID}/${initialData.account.id}`,
            access_token: access_token,
          });
          //console.log(responseConf)
          if (responseConf.data.state) {
            setConfiguration({
              approvedServiceText:
                responseConf.data.data?.approvedServiceText || "",
              informationPatientStep1:
                responseConf.data.data?.informationPatientStep1 || "",
              informationTelemedicine:
                responseConf.data.data?.informationTelemedicine || "",
              informedConsent: responseConf.data.data?.informedConsent || "",
              urlImage: responseConf.data.data?.urlImage || "",
              colorFont: responseConf.data.data?.colorFont || "",
              fontSize: responseConf.data.data?.fontSize || "",
              paymentText: responseConf.data.data?.paymentText || "",
            });
          }
        }
      } catch (error) {}
    }
    getFields();
  }, [initialData.account]);

  const steps = [
    <StepOneCLB
      next={handleNextStep}
      initialData={initialData}
      setShowModalError={setShowModalError}
      phoneNumber={phoneNumber}
      tipoSangre={tipoSangre}
      setErrorServer={setErrorServer}
      setInitialData={setInitialData}
      setPhoneNumber={setPhoneNumber}
      setTipoSangre={setTipoSangre}
      source={source}
      phoneNumber2={phoneNumber2}
      setPhoneNumber2={setPhoneNumber2}
      fieldSettings={fieldSettings}
      configuration={configuration}
    />,
    <StepTwo
      next={handleNextStep}
      setInitialData={setInitialData}
      initialData={initialData}
      prev={handlePrevStep}
      linkAllianz={true}
      setShowModalError={setShowModalError}
      setErrorServer={setErrorServer}
    />,
    <StepTreeCuenta
      next={handleNextStep}
      initialData={initialData}
      isPedienteAprobacion={isPedienteAprobacion}
      idAccount={idAccount}
      prev={handlePrevStep}
      setReservadoExitosamente={setReservadoExitosamente}
      reservadoExitosamente={reservadoExitosamente}
      source={source}
      setPayment={setPayment}
      setPaymentStatus={setPaymentStatus}
      configuration={configuration}
      setDeclined={setDeclined}
    />,
  ];

  useEffect(() => {
    //buscar el account
    if (existeCompania === "check") {
      setLoading(true);
      Get({ url: `${GET_ACCOUNT_SIN_TOKEN}/${idAccount}`, noToken: true })
        .then((response) => {
          //console.log(response)
          if (response.data.state) {
            setInitialData((prev) => ({
              ...prev,
              account: response.data.data,
            }));
            setStatusCuenta(response.data.data.active);
          } else {
            setExisteCompania("no");
          }

          setLoading(false);
        })
        .catch((error) => {
          setShowModalError(true);
          if (error.response) {
            setErrorServer(error.response);
          }
        });
    }
  }, [existeCompania]);

  const handleMessageSocket = (message) => {
    console.log(message);
    setPaymentStatus(message);
  };

  if (declined) {
    return (
      <Container
        fluid
        className="content py-5 h-100vh"
        style={{ fontFamily: theme.font }}
      >
        <DeclinadoLegalWarning
          children={
            <div className="text-center">
              <Button
                type="button"
                variant="secondary"
                onClick={() => {
                  window.location.reload();
                }}
              >
                Iniciar nuevamente
              </Button>
            </div>
          }
        />
      </Container>
    );
  }

  if (statusCuenta === false) {
    return (
      <Container
  fluid
  className="d-flex flex-column"
  style={{ minHeight: "100vh", backgroundColor: "#ffffff" }}
>
  {/* Header */}
  <header
    className="w-100 text-center py-2"
    style={{
      backgroundColor: "#f3f3f3",
      borderBottom: "1px solid #e0e0e0",
    }}
  >
    <span
      style={{
        fontSize: "0.95rem",
        fontWeight: "600",
        letterSpacing: "1px",
        textTransform: "uppercase",
        color: "#666666",
      }}
    >
      Página no disponible
    </span>
  </header>

  {/* Main Content */}
  <main className="flex-grow-1 d-flex align-items-center justify-content-center">
    <Row className="w-100 justify-content-center">
      <Col xs="12" md="8" lg="6" className="text-center px-4">
        <img
          src={imgOops}
          alt="Link no disponible"
          className="img-fluid mb-4"
          style={{
            maxHeight: "260px",
            filter: "grayscale(100%) contrast(120%)",
            opacity: 0.9,
          }}
        />

        <h1
          style={{
            fontSize: "3.2rem",
            fontWeight: "800",
            color: "#000000",
            marginBottom: "1rem",
          }}
        >
          ¡Este link ya no funciona!
        </h1>

        <p
          style={{
            fontSize: "1.1rem",
            color: "#666666",
            maxWidth: "480px",
            margin: "0 auto",
          }}
        >
          El enlace al que intentó acceder ya no se encuentra disponible.
        </p>
      </Col>
    </Row>
  </main>

  {/* Footer */}
  <footer
    className="w-100 text-center py-2"
    style={{
      backgroundColor: "#fafafa",
      borderTop: "1px solid #eaeaea",
    }}
  >
    <span
      style={{
        fontSize: "0.8rem",
        color: "#999999",
      }}
    >
      © {new Date().getFullYear()} Copyright
    </span>
  </footer>
</Container>



    
    );
  }

  return (
    <>
      {paymentStatus === "currentflow" ? (
        <>
          {loading ? (
            <LoadingList texto={t("cargando_datos")} />
          ) : existeCompania === "no" ? (
            <Container
              fluid
              className="content py-5"
              style={{ fontFamily: theme.font }}
            >
              <Row className="mb-4">
                <Col xs="12" md={{ span: 6, offset: 3 }}>
                  <Alert variant="info">
                    Esta intenando acceder a un link sin información, revise la
                    información y vuelve a intentarlo por favor.
                  </Alert>
                </Col>
              </Row>
            </Container>
          ) : (
            <>
              <ThemeProvider theme={theme}>
                <GlobalStyles
                  extraStyle={{
                    colorFont: configuration?.colorFont,
                    fontSize: configuration?.fontSize,
                  }}
                />
                <Container
                  fluid
                  className="content py-5"
                  style={{ fontFamily: theme.font }}
                >
                  {configuration?.urlImage && (
                    <div className="d-flex align-items-center justify-content-center mb-2 w-100">
                      <Image
                        src={configuration.urlImage}
                        className="doctor-foto-img"
                        style={{ maxHeight: "120px", maxWidth: "120px" }}
                      />
                    </div>
                  )}
                  {loading ? (
                    <LoadingList texto={t("cargando_datos")} />
                  ) : (
                    <>
                      {!startFromEPS && (
                        <Row className="mb-2">
                          <Col>
                            <div className="multi-step">
                              <ul className="multi-step-list">
                                <li
                                  className={`multi-step-item ${
                                    camino.filter((e) => e === 0).length > 0
                                      ? "current"
                                      : ""
                                  }`}
                                >
                                  <div className="item-wrap">
                                    <p className="item-title">Paso 1</p>
                                  </div>
                                </li>
                                <li
                                  className={`multi-step-item ${
                                    camino.filter((e) => e === 1).length > 0
                                      ? "current"
                                      : ""
                                  }`}
                                >
                                  <div className="item-wrap">
                                    <p className="item-title">Paso 2</p>
                                  </div>
                                </li>
                                <li
                                  className={`multi-step-item ${
                                    camino.filter((e) => e === 2).length > 0
                                      ? "current"
                                      : ""
                                  }`}
                                >
                                  <div className="item-wrap">
                                    <p className="item-title">Paso 3</p>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </Col>
                        </Row>
                      )}
                      {!startFromEPS &&
                        source === "autoagendamientonuevoeps" && (
                          <Row>
                            <Col
                              xs="12"
                              md={{ span: 8, offset: 2 }}
                              style={{ textAlign: "center" }}
                            >
                              <label className="font-size-08rem">
                                Respetado usuario: Recuerde que para cancelar o
                                reagendar su cita de medicina general/pediatría
                                deberá realizar el proceso con 2 horas de
                                anticipación y para los casos de consulta por
                                otras especialidades deberá realizarlo como
                                mínimo 24 horas antes, de lo contrario no se
                                realizará el reembolso del copago
                                correspondiente a la misma. Debe tener a la mano
                                su orden de remisión vigente no mayor a 90 días,
                                en los casos en que se requiera.
                              </label>
                            </Col>
                          </Row>
                        )}
                      {startFromEPS ? (
                        <Row>
                          <Col xs="12" md={{ span: 4, offset: 4 }}>
                            <div style={{ minHeight: "95vh" }}>
                              <StepEPSOnly />
                            </div>
                          </Col>
                        </Row>
                      ) : (
                        <Row>
                          <Col xs="12" md="12">
                            <div className="contenedor-allianz">
                              {steps[currentStep]}
                            </div>
                          </Col>
                        </Row>
                      )}
                    </>
                  )}
                </Container>
              </ThemeProvider>

              <ComponentModalErrorSever
                show={showModalError}
                handleClose={handleClose}
                error={errorServer}
              />
            </>
          )}
        </>
      ) : (
        <>
          <Container
            fluid
            className="content py-5 main"
            style={{ fontFamily: theme.font }}
          >
            <Row className="mb-4">
              <Col xs="12" md={{ span: 6, offset: 3 }} className="text-center">
                {paymentStatus === "DECLINED" ? (
                  <div>
                    <p>
                      Sr(a). Usuario: Su cita no pudo ser agendada. El tiempo
                      para realizar el pago de la cita se ha agotado o su pago
                      no fue aprobado, en caso de necesitar el agendamiento de
                      la cita por favor realice de nuevo el proceso. Gracias
                    </p>
                    <Button
                      type="button"
                      variant="secondary"
                      onClick={() => window.location.reload()}
                    >
                      Iniciar proceso
                    </Button>
                  </div>
                ) : paymentStatus === "PENDING" ? (
                  <p>
                    Sr(a). Usuario: Su cita está en proceso de pago. Recuerde
                    que tiene 15 minutos para realizar el pago, de lo contrario,
                    su cita no será agenda y deberá repetir el proceso de
                    agendamiento. Gracias
                  </p>
                ) : (
                  paymentStatus === "PAID" && (
                    <div>
                      <p>
                        Sr (a). Usuario: su cita fue pagada con éxito, su
                        servicio se encuentra en proceso de aprobación. Recibirá
                        la confirmación en la brevedad posible mediante mensaje
                        de texto y correo electrónico (verifique la bandeja de
                        correo no deseado) Para cancelar su cita comuníquese con
                        nosotros.
                      </p>
                      <Button
                        type="button"
                        variant="secondary"
                        onClick={() => {
                          //window.open("about:blank", "_self");
                          //window.close();
                          window.location.reload();
                        }}
                      >
                        Finalizar
                      </Button>
                    </div>
                  )
                )}
              </Col>
            </Row>
          </Container>
        </>
      )}
      {payment && (
        <SockJsClient
          url={`${BASE_URL_WS}/ws`}
          topics={[`/user/${payment.id}/queue/paymentStatus`]}
          onMessage={(message) => handleMessageSocket(message)}
        />
      )}
    </>
  );
}

export default withTranslation()(AgendamientoCuenta);
